<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="add-mt4channel"
  >
    <Form
      :push-list="pushList"
      ref="form"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { saveMt4Config } from '@/api/sys/mt4Chanel'
import Form from '@/components/sys/mt4Channel/Form'

export default {
  name: 'add',
  components:{
    Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    pushList:{}
  },
  data() {
    return {
      title: '新增MT4推送配置',
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      let params = {
        ruleId: formData.ruleId,
        name: formData.userName,
        mt4Id: formData.login,
        remark: formData.remark,
        status: formData.status,
        type:formData.type,
      }
      saveMt4Config(params).then((res) => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style>
@media screen and (min-width: 768px) {
  .add-mt4channel.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
